import {
    Grid,
    Button,
    Box
} from '@mui/material';
import DialogText from "./DialogText";

function RegisterConfirmTest(props) {
    const { goNextPage, goPreviousPage } = props;

    return (
        <Grid
            container
            height='100%'
            direction='column'
            justifyContent='center'
            overflow='hidden'>
            <Box
                sx={{
                    overflow: 'scroll',
                    padding: '0 20px'
                }}>
                <Box
                    sx={{
                        fontSize: '20px',
                        fontWeight: 'bold',
                        marginTop: '20px'
                    }}>
                서비스 이용약관에 대한 동의(필수)
                </Box>
                <DialogText></DialogText>
                <Box sx={{ height: '100px' }}></Box>
            </Box>
            <Box
                sx={{
                    position: 'fixed',
                    bottom: 0,
                    width: '100%',
                    textAlign: 'center',
                    padding: '20px 0',
                    background: 'white'
                }}>
                <Button variant="contained" sx={{ width: "40%", margin: "5px", background: "#0092a2" }} onClick={goNextPage}>동의 후 다음 단계로</Button>
                <Button variant="outlined" sx={{ width: "40%", margin: "5px", border: "1px solid gray", color: "gray" }} onClick={goPreviousPage}>취소</Button>
            </Box>
        </Grid>
    )
}
export default RegisterConfirmTest;